import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      marginTop: 5,
      fontFamily: 'Roboto',
      fontSize: 14,
      alignSelf: 'start',
      color: '#000000',
    },
    select: {
      marginTop: 10,
      marginBottom: 10,
      height: 40,
      width: '100%',
      backgroundColor: 'white',
      '& div': {
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  }),
);
